import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [user, setUser] = useState(undefined); // undefined = loading
  const [admin, setAdmin] = useState(undefined);
  const [serverOffset, setServerOffset] = useState(0);

  const loadConfig = useCallback(async () => {
    try {
      const { data } = await api.get("/public/config");
      setConfig(data);
      setServerOffset(new Date(data.server_now).getTime() - Date.now());
      if (localStorage.getItem("lostdc_sound") === null && data?.media?.sounds_enabled === false) {
        localStorage.setItem("lostdc_sound", "off");
      }
    } catch (e) {
      console.error("config load failed", e);
    }
  }, []);

  const loadUser = useCallback(async () => {
    if (!localStorage.getItem("lostdc_token")) { setUser(null); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("lostdc_token");
      setUser(null);
    }
  }, []);

  const loadAdmin = useCallback(async () => {
    if (!localStorage.getItem("lostdc_admin_token")) { setAdmin(null); return; }
    try {
      const { data } = await api.get("/auth/admin/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem("lostdc_admin_token");
      setAdmin(null);
    }
  }, []);

  useEffect(() => {
    loadConfig();
    loadUser();
    loadAdmin();
  }, [loadConfig, loadUser, loadAdmin]);

  const serverNow = useCallback(() => Date.now() + serverOffset, [serverOffset]);

  const logout = () => {
    localStorage.removeItem("lostdc_token");
    setUser(null);
  };
  const adminLogout = () => {
    localStorage.removeItem("lostdc_admin_token");
    setAdmin(null);
  };

  return (
    <AppContext.Provider value={{ config, loadConfig, user, setUser, admin, setAdmin, serverNow, logout, adminLogout, reloadUser: loadUser }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
